import { t } from "i18next";

/**
 * Custom error for validation failures
 */
export class ValidationError extends Error {
  constructor(message, errors) {
    super(message || t("errors.validationFailed"));
    this.name = "ValidationError";
    this.errors = errors;
  }
}
